(function () {
  const isMobile = () => {
    return window.innerWidth < 842;
  };

  const hideElements = () => {
    if (!isMobile()) return;
    const elements = document.querySelectorAll('.hide-on-search');
    elements.forEach(element => element.classList.add('search-active'));
  }

  const showElements = () => {
    const elements = document.querySelectorAll('.hide-on-search.search-active');
    elements.forEach(element => element.classList.remove('search-active'));
  }

  const search = document.querySelector('.search');

  if (search) {
    const form = search.querySelector('form.search-form');
    const icon = search.querySelector('button');

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      icon.textContent = 'search';
      // showElements();
      hideElements();
    });

    icon.addEventListener('click', (e) => {
      e.preventDefault();
      if (!search.classList.contains('active')) {
        search.classList.add('active');
        icon.querySelector('i').textContent = 'close';
        hideElements();

      } else {
        search.classList.remove('active');
        icon.querySelector('i').textContent = 'search';
        showElements();
      }
    });

  }

})();
